import {
  Component, ProvideReactive, Vue,
} from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import GraphQLIntrospectionModule from '@/store/graphql-introspection';
import PimcoreEntityIntrospection from '@/classes/graphql-introspection/PimcoreEntityIntrospection';

@Component
export default class PimcoreIntrospectionMixin extends Vue {
  graphQLIntrospectionModule = getModule(GraphQLIntrospectionModule, this.$store);

  pimcoreEntityIntrospection: PimcoreEntityIntrospection | null = null;

  @ProvideReactive()
  get pimcoreIntrospection() {
    return this.pimcoreEntityIntrospection;
  }

  async getPimcoreIntrospection(entityName: string) {
    return this.graphQLIntrospectionModule.getPimcoreIntrospection(entityName);
    // return (new Promise<any>((resolve: any, reject: any) => {
    //   if (!this.graphQLIntrospectionModule) {
    //     setTimeout(() => {
    //       this.graphQLIntrospectionModule = getModule(GraphQLIntrospectionModule, this.$store);
    //       resolve(this.getPimcoreIntrospection(entityName));
    //     }, 100);
    //   } else {
    //     resolve(this.graphQLIntrospectionModule.getPimcoreIntrospection(entityName));
    //   }
    // }));
  }

  async initPimcoreIntrospection(entityName: string) {
    this.pimcoreEntityIntrospection = await this.getPimcoreIntrospection(entityName);
  }
}
